if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty-input__input');
      this.currentQty = this.input ? this.input.value : 0;

      this.addEventListener('click', this.handleClick.bind(this));
      if (this.input) {
        this.input.addEventListener('focus', QuantityInput.handleFocus);
        this.input.addEventListener('keydown', this.handleKeydown.bind(this));
        this.input.addEventListener('change', () => {
          this.currentQty = this.input.value;
        });
      }
    }

    /**
     * Handles 'click' events on the quantity input element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      const btn = evt.target.closest('.qty-input__btn');
      if (!btn || btn.disabled) return;
      evt.preventDefault();

      if (!this.input) this.input = this.querySelector('.qty-input__input');
      if (!this.input) return;

      this.currentQty = this.input.value;

      if (btn.name === 'plus') {
        this.input.stepUp();
      } else {
        this.input.stepDown();
      }

      if (this.input.value !== this.currentQty) {
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.currentQty = this.input.value;
      }
    }

    /**
     * Handles 'focus' events on the quantity input element.
     * @param {object} evt - Event object.
     */
    static handleFocus(evt) {
      if (window.matchMedia('(pointer: fine)').matches) {
        evt.target.select();
      }
    }

    /**
     * Handles 'keydown' events on the input field.
     * @param {object} evt - Event object.
     */
    handleKeydown(evt) {
      if (evt.key !== 'Enter') return;
      evt.preventDefault();

      if (this.input.value !== this.currentQty) {
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.currentQty = this.input.value;
      }
      this.input.blur();
    }
  }

  customElements.define('quantity-input', QuantityInput);
}
